import { z } from 'zod';
export var SecretType;
(function (SecretType) {
    /**
     * A federated token set is a collection of OAuth tokens from the third-party providers.
     * Use these tokens to get access to the third-party APIs.
     */
    SecretType["FederatedTokenSet"] = "federated_token_set";
})(SecretType || (SecretType = {}));
export const secretTypeGuard = z.nativeEnum(SecretType);
